import gql from 'graphql-tag';

export const lookupVisitorWatchlist = gql`
  query LookupVisitorWatchlist(
    $organizationId: String!
    $lookupVisitor: LookupVisitorInput!
  ) {
    lookupVisitorWatchlist(
      organizationId: $organizationId
      lookupVisitor: $lookupVisitor
    ) {
      matches {
        watchlistRuleId
        visitorWatchlistId
        approvalRequired
      }
    }
  }
`;
